export default "__VITE_ASSET__eM9iCEAg__"